import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { useElement, useOuterEvent } from '../../../hooks';

const usePickerButton = (
  onClose?: () => void
): [
  boolean,
  Dispatch<SetStateAction<boolean>>,
  HTMLElement | null,
  (instance: HTMLElement | null) => void,
  HTMLElement | null,
  (instance: HTMLElement | null) => void
] => {
  const [open, setOpen] = useState(false);
  const [popoverEl, setPopoverRef] = useElement<HTMLElement>();
  const [buttonEl, setButtonEl] = useElement<HTMLElement>();

  const closeWithCallback = () => {
    setOpen(false);
    onClose?.();
  };
  useOuterEvent('mousedown', [popoverEl, buttonEl], () => {
    if (open) closeWithCallback();
  });

  useEffect(() => {
    const closePopover = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeWithCallback();
        // stop propagation if triggered inside the picker to prevent closing a modal
        if (e.currentTarget === popoverEl) {
          e.stopPropagation();
          buttonEl?.focus();
        }
      }
    };
    document.addEventListener('keydown', closePopover);
    popoverEl?.addEventListener('keydown', closePopover);

    return () => {
      document.removeEventListener('keydown', closePopover);
      popoverEl?.removeEventListener('keydown', closePopover);
    };
  }, [popoverEl]);

  return [open, setOpen, popoverEl, setPopoverRef, buttonEl, setButtonEl];
};

export default usePickerButton;
